import React from 'react'
import { useIntl } from 'react-intl'
import { FormSubGroup, Label } from '../../layout'
import { SelectContainer, useTowingJobFilterContext } from '../context'
import { JobDayFilter as JobDayFilterType } from '../../../functions/graphqlApi/types/towingOrder'
import { FilterCheckBox } from '../components/FilterCheckBox'
import { towingJobFilterMessages } from '../messages'
import { formatMessageSafe } from '../../../util/translateInputOptions'

export const JobDayFilter = () => {
  const { values, setValues } = useTowingJobFilterContext()
  const { jobDayFilters, hidePreOrders } = values.filters
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  const toggleHidePreOrders = () => {
    setValues({
      ...values,
      filters: {
        ...values.filters,
        hidePreOrders: !hidePreOrders,
        jobDayFilters: jobDayFilters.filter(value => value !== 'tomorrow'),
      },
    })
  }

  const handleJobDayFilter = (filter: JobDayFilterType) => {
    const updatedJobDayFilters = jobDayFilters.includes(filter)
      ? jobDayFilters.filter(value => value !== filter)
      : [...jobDayFilters, filter]

    setValues({
      ...values,
      filters: {
        ...values.filters,
        jobDayFilters: updatedJobDayFilters,
      },
    })
  }

  return (
    <FormSubGroup>
      <Label>{formatMessage(towingJobFilterMessages.jobDayLabel)}</Label>
      <SelectContainer>
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
          <FilterCheckBox
            checked={jobDayFilters.includes('yesterday')}
            label={formatMessage(towingJobFilterMessages.jobDayYesterday)}
            onChange={() => handleJobDayFilter('yesterday')}
          />
          <FilterCheckBox
            checked={jobDayFilters.includes('today')}
            label={formatMessage(towingJobFilterMessages.jobDayToday)}
            onChange={() => handleJobDayFilter('today')}
          />
          <FilterCheckBox
            disabled={values.filters.hidePreOrders}
            checked={jobDayFilters.includes('tomorrow')}
            label={formatMessage(towingJobFilterMessages.jobDayTomorrow)}
            onChange={() => handleJobDayFilter('tomorrow')}
          />
          <FilterCheckBox checked={hidePreOrders} label={formatMessage(towingJobFilterMessages.jobDayHidePreOrders)} onChange={toggleHidePreOrders} />
        </div>
      </SelectContainer>
    </FormSubGroup>
  )
}
